const root = `td-register/detentiont/`
const urls = {
  getDetail: root + 'detail',
  getList: root + 'page',
  remove: root + 'remove',
  add: root + 'save',
  detail: root + 'detail',
  update: root + 'update',
  existDetenteDecisionNo: root + 'existDetenteDecisionNo',
  existTransferCaseNo: root + 'existTransferCaseNo'
}

// 获取列表页数据
export const getList = obj => {
  return $http.get(urls.getList, obj)
}
// 删除列表中目标数据
export const remove = obj => {
  let ids = Array.isArray(obj) ? obj.map(z => z.id).join(',') : obj.id
  return $http.post(`${urls.remove}?ids=${ids}`)
}

export const add = obj => {
  return $http.post(urls.add, obj)
}
export const detail = id => {
  return $http.get(urls.detail, { id: id })
}
export const detailByPenalizeId = penalizeId => {
  return $http.get(urls.detail, { penalizeId: penalizeId })
}
export const update = obj => {
  return $http.post(urls.update, obj)
}
export const existDetenteDecisionNo = obj => {
  return $http.get(urls.existDetenteDecisionNo, obj)
}
export const existTransferCaseNo = obj => {
  return $http.get(urls.existTransferCaseNo, obj)
}
export default {
  add,
  update,
  detail,
  getList,
  remove,
  detailByPenalizeId,
  existDetenteDecisionNo
}
